import {
    Menu,
    MenuButton,
    MenuItem,
    MenuList,
    IconButton,
} from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FeeModel } from "providers/loans/fee.model";

interface FeeTableActionsMenuProps {
    fee: FeeModel;
    handleEdit: (id: number) => void;
    handleDelete: (id: number) => void;
}

export function FeeTableActionsMenu({
    fee,
    handleEdit,
    handleDelete,
}: FeeTableActionsMenuProps) {
    return (
        <Menu>
            <MenuButton
                as={IconButton}
                aria-label="Options"
                variant={"link"}
                icon={<FontAwesomeIcon icon={["far", "ellipsis-vertical"]} />}
            />
            <MenuList>
                <MenuItem
                    icon={<FontAwesomeIcon icon={["far", "edit"]} />}
                    onClick={() => handleEdit(fee.id)}
                >
                    Edit
                </MenuItem>
                <MenuItem
                    icon={<FontAwesomeIcon icon={["far", "trash-can"]} />}
                    color={"red"}
                    onClick={() => handleDelete(fee.id)}
                >
                    Delete
                </MenuItem>
            </MenuList>
        </Menu>
    );
}
